import React from 'react';
import { FormSpy, useField } from 'react-final-form';
import { Combobox, FormField, FormHelp, Label } from '@zillow/constellation';
import HighlightedComboboxOption from './HighlightedComboboxOption';
import useDebouncedState from '../../../../../hooks/useDebouncedState';
import { useAddressAutocomplete, useAddressOptions, validateAddress } from './AddressField.utils';

export default function AddressField({ previouslyEnteredListings, ...rest }) {
  const [partialAddress, setPartialAddress] = useDebouncedState('', 200, { maxWait: 600, trailing: true });
  const { data: addressSuggestions, isFetching: isFetchingAddressSuggestions } = useAddressAutocomplete(partialAddress);
  const addressOptions = useAddressOptions(addressSuggestions, previouslyEnteredListings, partialAddress);
  const { input, meta } = useField('fullAddress', {
    validate(value) {
      return validateAddress(value, addressSuggestions, previouslyEnteredListings);
    },
  });

  const displayError = meta.submitFailed && !meta.modifiedSinceLastSubmit && Boolean(meta.error);
  return (
    <>
      <FormField
        label={<Label>Street address</Label>}
        control={
          <Combobox
            loading={isFetchingAddressSuggestions}
            onChange={input.onChange}
            value={input.value}
            options={addressOptions}
            optionFilter={null}
            renderOption={({ label: _label, ...restParams }) => {
              return <HighlightedComboboxOption label={_label} search={partialAddress} {...restParams} />;
            }}
            focusFirstOption
            freeForm
          />
        }
        description={
          <FormHelp error={displayError}>{displayError ? meta.error : 'Enter a USPS-validated address.'}</FormHelp>
        }
        required
        {...rest}
      />
      <FormSpy subscription={{ values: true }} onChange={({ values }) => setPartialAddress(values.fullAddress)} />
    </>
  );
}
